import React, { useEffect, useState } from 'react';
import { useParams, useLocation, Prompt } from 'react-router-dom';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import { useTheme, withStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';

import { useAuth } from 'context/AuthContext';
import { useExitPrompt, refreshReloadPrompt } from 'hooks';
import { border } from 'variables/general';
import {
  styles,
  SubmitButton,
  DeleteText,
  DeleteButton,
  Buttons,
  ConfirmDelete,
  ConfirmDeleteContainer,
} from './styles';
import Button from '../Button';

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const DialogActions = withStyles(() => ({
  root: {
    margin: 0,
    padding: '1em',
    borderTop: border,
    display: 'flex',
    justifyContent: 'space-between',
  },
}))(MuiDialogActions);

const DialogHeader = withStyles(styles)(({ classes, onClose }) => (
  <MuiDialogTitle className={classes.root}>
    {onClose ? (
      <IconButton className={classes.closeButton} onClick={onClose}>
        <CloseIcon />
      </IconButton>
    ) : null}
  </MuiDialogTitle>
));

const DialogContent = withStyles((disabletoppadding) => ({
  root: { padding: `${disabletoppadding ? '0 1.5em 1.5em' : '1.5em'}` },
}))(MuiDialogContent);

export default ({
  className,
  children,
  open,
  handleClose,
  typeText,
  submitForm,
  handleDelete,
  disableTopPadding,
  maxWidth,
  buttonText,
  disableDelete,
  blockRouteChange,
  bookingScheduler,
}) => {
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [, setShowExitPrompt] = useExitPrompt(blockRouteChange);

  useEffect(() => {
    setShowExitPrompt(blockRouteChange);
    if (!blockRouteChange) {
      window.removeEventListener('beforeunload', refreshReloadPrompt);
    }

    () => () => {
      window.removeEventListener('beforeunload', refreshReloadPrompt);
    };
  }, [blockRouteChange]);

  const { id } = useParams();
  const { pathname } = useLocation();
  const routeDepth = pathname.split('/').length - 1;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  let buttonTextLabel = '';
  if (buttonText) {
    buttonTextLabel = buttonText;
  } else if (id !== 'add') {
    buttonTextLabel = 'Save Changes';
  } else if (typeText) {
    buttonTextLabel = `Add ${typeText}`;
  }

  let isUser = false;

  if (!bookingScheduler) {
    const {
      currentUser: {
        data: { id: userId },
      },
    } = useAuth();

    isUser = pathname === `/admins/${userId}`;
  }

  function toggleDelete() {
    setDeleteDialog(!deleteDialog);
  }

  return (
    <Dialog
      fullScreen={fullScreen}
      fullWidth
      onClose={handleClose}
      open={open}
      maxWidth={maxWidth}
      TransitionComponent={Transition}
      className={className}
    >
      <Prompt
        when={blockRouteChange}
        message="You have unsaved changes. Are you sure?"
      />
      <DialogHeader onClose={handleClose} />
      <DialogContent disabletoppadding={disableTopPadding}>
        {children}
      </DialogContent>
      <DialogActions>
        {id &&
          id !== 'add' &&
          handleDelete &&
          !disableDelete &&
          !isUser &&
          routeDepth <= 2 && (
            <DeleteButton>
              <Button onClick={toggleDelete} variant="outlined" color="error">
                Delete {typeText}
              </Button>

              {deleteDialog && (
                <ConfirmDeleteContainer>
                  <ConfirmDelete>
                    <DeleteText>
                      Are you sure you want to delete this {typeText}?
                    </DeleteText>

                    <Buttons>
                      <Button
                        onClick={handleDelete}
                        variant="outlined"
                        color="error"
                      >
                        Confirm Delete
                      </Button>

                      <Button onClick={toggleDelete} variant="contained">
                        Cancel
                      </Button>
                    </Buttons>
                  </ConfirmDelete>
                </ConfirmDeleteContainer>
              )}
            </DeleteButton>
          )}

        <SubmitButton variant="contained" color="primary" onClick={submitForm}>
          {buttonTextLabel}
        </SubmitButton>
      </DialogActions>
    </Dialog>
  );
};
